import ShopifyClient from "shopify-buy";
import { isMobile } from "./helpers";
import _isEmpty from "lodash/isEmpty";

export const config = {
    data() {
        return {
            POS_MODE: window.CONFIG.POS_MODE,
            shopifyDomain: process.env.MIX_SHOPIFY_URL
        }
    }
}

export const helpers = {
    methods: {
        trimObjValues(data) {
            Object.keys(data).forEach(objKey => {
                data[objKey] = _.isString(data[objKey]) ? data[objKey].trim() : data[objKey];
            });

            return data;
        },
        removeQuery(query) {
            const queryList = Object.assign({}, this.$route.query);
            delete query[query];
            this.$router.replace({ queryList });
        }
    }
}

export const userMixin = {
    methods: {
        getCurrentUser() {
            return new Promise((resolve, reject) => {
                axios({
                    url: "/users/0",
                    method: "GET",
                }).then(user => {
                    user = helpers.methods.trimObjValues(user.data);
                    resolve(user);
                }).catch(error => {
                    reject(error.response.data.status.message);
                })
            })
        },
        setDefaultAvatar(target) {
            $(target).attr("src", "/images/users/avatar.png")
        }
    }
};

export const heapAnalytics = {
    methods: {
        track(name, properties) {
            window.heap.track(name, properties);
        },
        trackAll(name, properties) {
            this.track(name, properties);
        }
    }
};

export const configuratorMixins = {
    methods: {
        restartBuild() {
            window.localStorage.removeItem("session-price");
            window.localStorage.removeItem("session-draft");
            window.localStorage.removeItem("vuex-build");
            this.$store.dispatch("changeUserDraftId", null);
        }
    }
};

export const checkoutMixins = {
    methods: {
        async processCheckout(draftId, where, pageLocation) {
            this.trackAll('Client: Click Checkout 3', { page_location: pageLocation });
            this.changeLoadingText("PROCESSING CHECKOUT");
            this.changeShowLoadingOverlay(true);

            axios({
                url: `/checkout-fast/${draftId}`,
                headers: {
                    token: CONFIG.SESSION
                }
            }).then(async (response) => {
                const disabledProducts = this.$refs.specs.getDisabledProducts();
                if (!_isEmpty(disabledProducts)) {
                    return Promise.reject({
                        response: {
                            data: "The following products are no longer available:<br><br>" +
                                Object.values(disabledProducts).join("<br>")
                        }
                    });
                }

                const activeBuild = this.activeBuild || this.build;
                const checkoutList = [];
                const hidden = [];
                const addPart = function addPart(part) {
                    const variant = {
                        variantId: part.shopify_graph_id,
                        quantity: part.quantity
                    };

                    if (+part.is_hidden) {
                        hidden.push(part.shopify_variant_id);
                    }

                    checkoutList.push(variant);
                };

                Object.keys(activeBuild).forEach((key) => {
                    if (Array.isArray(activeBuild[key])) {
                        activeBuild[key].forEach((part) => {
                            if (+part.id && part.shopify_graph_id) {
                                addPart(part);
                            }
                        });
                    } else {
                        if (+activeBuild[key].id && activeBuild[key].shopify_graph_id) {
                            addPart(activeBuild[key]);
                        }
                    }
                });

                let shopifyCheckout = null;
                const customAttributes = [
                    {
                        key: "bld_number",
                        value: draftId
                    },
                    {
                        key: "source_device",
                        value: this.getDeviceType()
                    },
                    {
                        key: "heap_uuid",
                        value: localStorage.getItem("heap-uuid")
                    },
                    {
                        key: "checkout",
                        value: where
                    },
                    {
                        key: "preBuild",
                        value: "0"
                    }
                ];

                if (hidden.length) {
                    customAttributes.push({
                        key: "hidden",
                        value: hidden.join("|")
                    });
                }

                const shopifyClient = await ShopifyClient.buildClient({
                    domain: process.env.MIX_SHOPIFY_DOMAIN,
                    storefrontAccessToken: process.env.MIX_SHOPIFY_SDK_KEY
                });
                let currencyCode = {};

                if (this.$store.state.User.location.country_code == "CA") {
                    currencyCode = { presentmentCurrencyCode: "CAD" };
                }

                await shopifyClient.checkout.create({ customAttributes, ...currencyCode }).then(checkout => {
                    shopifyCheckout = checkout;
                });

                shopifyClient.checkout.addLineItems(
                    shopifyCheckout.id,
                    checkoutList
                ).then(() => {
                    location.href = shopifyCheckout.webUrl;
                }).catch(() => {
                    this.changeShowLoadingOverlay(false);
                });
            }).catch((error) => {
                this.showErrorModal(error.response.data);
                this.changeShowLoadingOverlay(false);
            });
        },
        getDeviceType() {
            const regex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
            return regex.test(navigator.userAgent) ? "mobile" : "desktop";
        }
    }
};

export const landingPagesMixin = {
    methods: {
        sendToConfigurator(bldNumber, checkout = false) {
            axios({
                url: `/drafts/${bldNumber}/influencer`,
                method: "POST"
            }).then(async (response) => {
                let price = 1000;
                let draft = response.data;
                let step = isMobile() ? "step4-mobile" : "step4";

                if (checkout) {
                    step = "step5";
                }

                await this.$store.dispatch("changeDraftId", null);
                window.localStorage.setItem('session-draft', draft);
                window.localStorage.setItem('session-price', price);
                this.$router.push({
                    name: step,
                    query: {
                        price,
                        draft
                    }
                });
            });
        }
    }
};
